import { createUseStyles } from "react-jss";
import { colors } from "../../../../../constants/colors";
import trashIcon from "../../../../../resources/images/trash-icon.svg";
import checkIcon from "../../../../../resources/images/check-blue-icon.svg";
import featuredIcon from "../../../../../resources/images/featured-icon.svg";
import trashRedIcon from "../../../../../resources/images/trash-red-icon.svg";
import featuredRedIcon from "../../../../../resources/images/featured-red-icon.svg";

const styles = createUseStyles(theme => ({
  preview: {
    display: "flex",
    width: "100%",
    minHeight: theme?.progress >= 1 && theme?.progress < 100 ? "100px" : "70px",
    margin: "0 auto",
    position: "relative",
    boxSizing: "border-box",
    transition: "all .15s linear",
    border: "1px solid " + colors.lightGrey,
    borderRadius: "12px",
    padding: "16px",
  },
  previewError: {
    extend: "preview",
    border: "1px solid " + colors.mediumRed,
    backgroundColor: colors.veryLightRed
  },
  content: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  contentNoBar: {
    extend: 'content',
    paddingBottom: '0px', // or reduce vertical padding as needed
  },
  wrapper: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  progressBarWrapper: {
    display: "flex",
    alignItems: "center",
  },
  progressContainer: {
    width: '100%',
    height: '10px',
    backgroundColor: colors.lightGrey,
    borderRadius: '10px',
    overflow: 'hidden',
    marginRight: '10px',
  },
  progressFill: {
    height: '100%',
    width: ({ progress }) => `${progress}%`,
    backgroundColor: ({ theme }) => theme.progress.accentColor || colors.brightBlue,
    transition: 'width 0.3s ease',
  },
  fileIcon: {
    backgroundSize: "32px 32px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "36px",
    height: "36px",
    backgroundImage: `url(${featuredIcon})`,
    marginRight: "10px",
  },
  fileRedIcon: {
    extend: "fileIcon",
    backgroundImage: `url(${featuredRedIcon})`
  },
  icon: {
    backgroundSize: "20px 20px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "25px",
    height: "25px",
    backgroundImage: `url(${checkIcon})`
  },
  cancelIcon: {
    extend: ["icon", "thrashIconHover"],
    cursor: "pointer",
    backgroundImage: `url(${trashIcon})`,
    flexShrink: 0,
    "&:hover": {
      backgroundColor: colors.brightBlue
    },
  },
  cancelRedIcon: {
    extend: ["icon", "thrashIconHover"],
    cursor: "pointer",
    backgroundImage: `url(${trashRedIcon})`,
    paddingLeft: "8px",
    "&:hover": {
      backgroundColor: colors.lightRed
    },
  },
  thrashIconHover: {
    width: "36px",
    height: "36px",
    position: "absolute",
    right: 6,
    borderRadius: "10px",
  },
  errorMessage: {
    fontSize: "14px",
    color: colors.darkRed,
    fontWeight: "500",
    maxWidth: "90%",
  },
  tryAgain: {
    fontSize: "14px",
    color: colors.darkRed,
    fontWeight: "600",
    marginTop: "4px",
    cursor: "pointer"
  },
  title: {
    fontSize: "14px",
    color: colors.grey,
    fontWeight: "500",
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    whiteSpace: "normal",
    wordBreak: "break-word",
    marginRight: "30px",
  },
  titleError: {
    fontSize: "14px",
    color: colors.brightRed,
    fontWeight: "400",
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    whiteSpace: "normal",
    wordBreak: "break-word",
    marginRight: "30px",
  },
}))

export default styles;
